

import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'my-app',
    templateUrl: 'app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AppComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
